import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RegionService } from '../../../services/region/region.service';
import { Region } from '../../../model/region.model';
import 'rxjs/add/operator/map';
import { LicenseDataService } from '../../../services/agentLicense/license-data.service';
import { InsuranceService } from '../../../services/insurance/insurance.service';
import { UploadService } from '../../../services/upload/upload.service';
import { documentInformation } from '../../../model/document.model';
import { FormBuilder, FormControl } from '@angular/forms';
import { SearchTermservice } from '../../../services/search/search-service.service';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { ParLicenseService } from '../../../services/par_license/par-license.service';
import * as momenttimezone from 'moment-timezone';
import { ChangeLogService } from '../../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-par-license-dialogue',
  templateUrl: './par-license-dialogue.component.html',
  styleUrls: ['./par-license-dialogue.component.css']
})
export class ParLicenseDialogueComponent implements OnInit {
  isFileChanged: boolean = false;
  states: any = [];
  statesList: any = [];
  data = {
    issueDate: Date,
    issueState: '',
    licenseNumber: '',
    expirationDate: Date,
    fileName: '',
    docId: '',
    documentType: '',
    documentName: '',
    uploadDate: new Date(),
    documentLink: '',
  }
  loginId: any;
  minDate = new Date();
  externalURL: any;
  documentInfo: documentInformation = new documentInformation();
  date;
  errorMsg: boolean = false;
  isdatewrong: boolean;
  datewrongmsg: string;
  logFormData: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  uploadFlag: boolean = true;
  matSpinner: boolean = false;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  previousValues: any = [];
  constructor(
    private changelogservice: ChangeLogService,
    private uploadService: UploadService,
    public insuranceservice: InsuranceService,
    public dialogRef: MatDialogRef<ParLicenseDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public licenseData: any,
    private regionService: RegionService,
    private http: Http, private router: Router,
    public fb: FormBuilder,
    public search: SearchTermservice,
    public parLicenseService: ParLicenseService,
    public googleAnalyticsService: GoogleAnalyticsService,
    public ref: ChangeDetectorRef) {
    this.date = new FormControl(new Date(), );
  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.search.getListOfStates().subscribe(res => {
      this.statesList = res.States;
      this.statesList.forEach(state => {
        this.states.push(state.Code);
      });
    }, error => {
      this.errorMessage = "All States" + error;
      this.errorEnable = true;
      this.scrollTop()
    });
    if (this.licenseData.type === "update") {
      const setTime = new Date(this.licenseData.data.ExpirationDate);
      setTime.setHours(19);
      setTime.setMinutes(59);
      setTime.setSeconds(59);
      const estTimeZone = 'America/New_York';
      const format = 'YYYY-MM-DDTHH:🇲🇲:ss.SSSZ';
      var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
      /*** The following logic for Daylight Savings ***/
      if (testTimeZone.includes('-05:00')) {
        testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
      }
      this.data.fileName = this.licenseData.data.FileName;
      this.data.expirationDate = this.licenseData.data.ExpirationDate;
      this.data.issueDate = this.licenseData.data.IssueDate;
      this.data.issueState = this.licenseData.data.IssueState;
      this.data.licenseNumber = this.licenseData.data.LicenseNumber;
      this.data.docId = this.licenseData.data._id;
      this.data.documentLink = this.licenseData.data.DocumentLink;
      this.data.documentName = this.licenseData.data.DocumentTypeName;
      this.data.documentType = this.licenseData.data.DocumentTypeCode;
      this.data.uploadDate = new Date();
    } else if (this.licenseData.type === 'create') {
      this.data.documentName = this.licenseData.data.DocumentTypeName;
      this.data.documentType = this.licenseData.data.DocumentTypeCode;
    }
  }

  scrollTop() {
    const element = document.getElementById('scrollToTop');
    element.scrollIntoView();
  }

  clear() {
    this.dialogRef.close();
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Uploaded a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.fileName = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    //It will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  saveDocument() {
    this.matSpinner = true;
    this.uploadFlag = false;
    if (this.isFileChanged === false && this.licenseData.type === 'update') {
      this.externalURL = this.data.documentLink;
      this.submit();
    }
    else {
      let today = new Date();
      const estTimeZone = 'America/New_York';
      let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
      uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
      var filePath = "Par/" + "ParLicenseDocs/" + this.data.documentType + "/";
      this.data.fileName = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": this.newFilePath1
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
          this.externalURL = this.newFilePath1;
          this.data.documentLink = this.externalURL;
          this.submit();
        });
      }, error => {
        this.errorMessage = "File upload: " + error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop()
      });
    }
  }

  submit() {
    this.logFormData = {
      "document_type": this.licenseData.data.DocumentTypeName,
      "document_category": this.licenseData.data.DocumentCategory,
      "transaction_type": "Add",
      "modified_by": this.loginId
    }
    if (this.licenseData.type === "create") {
      this.parLicenseService.createNewParLicense(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Created a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
        this.dialogRef.close();
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
          this.errorMessage = 'PAR Change Logs' + ' ' + err;
          this.errorEnable = true;
          this.matSpinner = false;
          this.scrollTop()
        });
      }, error => {
        this.errorMessage = "Create Par License document: " + error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop()
      })
    } else {
      this.parLicenseService.updateParLicense(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Updated a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
        this.dialogRef.close();
        if (this.logFormData.transaction_type == "Add") {
          this.logFormData.transaction_type = "Edit";
          this.logFormData.document_category = this.licenseData.category;
          this.previousValues = localStorage.getItem('old');
          this.logFormData.previous_fields = JSON.parse(this.previousValues);
          this.logFormData.collection_name = "par_license_documents";
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errorMessage = 'PAR Change Logs' + ' ' + err;
            this.errorEnable = true;
            this.matSpinner = false;
            this.scrollTop()
          });
        }
      }, error => {
        this.errorMessage = "Update Par License document: " + error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop();
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/components/par-license/par-license-dialogue/par-license-dialogue.component.ts